/** Tiny inline trend line. `up` colors it (green up / red down / muted flat). */
export const Sparkline = ({
  values,
  up,
  width = 88,
  height = 22,
}: {
  values: number[];
  up?: boolean | null;
  width?: number;
  height?: number;
}) => {
  if (values.length < 2) return <span className="muted" style={{ fontSize: 11 }}>—</span>;

  const pad = 3;
  const max = Math.max(...values);
  const min = Math.min(...values);
  const range = max - min || 1;
  const dx = width / (values.length - 1);
  const y = (v: number) => height - pad - ((v - min) / range) * (height - 2 * pad);
  const pts = values.map((v, i) => `${(i * dx).toFixed(1)},${y(v).toFixed(1)}`).join(' ');
  const color =
    up == null ? 'var(--p-muted-fg)' : up ? 'var(--status-success-ink, #15803d)' : 'var(--status-error-ink, #b91c1c)';
  const lastX = (values.length - 1) * dx;
  const lastY = y(values[values.length - 1]);

  return (
    <svg width={width} height={height} style={{ display: 'block' }} aria-hidden>
      <polyline points={pts} fill="none" stroke={color} strokeWidth={1.5} strokeLinejoin="round" strokeLinecap="round" />
      <circle cx={lastX} cy={lastY} r={2} fill={color} />
    </svg>
  );
};
